import React from 'react';

// Widgets.
import Label from './form/Label';
import WidgetInput from './widgets/WidgetInput';
import Email from './widgets/Email';
import WidgetHidden from './widgets/WidgetHiddenInput';
import WidgetGroup from './widgets/WidgetGroup';
import WidgetText from './widgets/WidgetText';
import WidgetNumberWithButtons from './widgets/WidgetNumberWithButtons';
import WidgetTextArea from './widgets/WidgetTextArea';
import WidgetDate from './widgets/WidgetDate';
import WidgetSelect from './widgets/WidgetSelect';
import WidgetStatic from './widgets/WidgetStatic';

// Interfaces.
import BookprocessWidgetProps from './widgets/interfaces/BookprocessWidgetPropsInterface';
import PropsDate from './widgets/interfaces/PropsDateInterface';
import PropsEmail from './widgets/interfaces/PropsEmailInterface';
import PropsGroup from './widgets/interfaces/PropsGroupInterface';
import PropsHidden from './widgets/interfaces/PropsHiddenInterface';
import PropsNumber from './widgets/interfaces/PropsNumberInterface';
import PropsText from './widgets/interfaces/PropsTextInterface';
import PropsTime from './widgets/interfaces/PropsTimeInterface';
import PropsSelect from './widgets/interfaces/PropsSelectInterface';
import PropsStatic from './widgets/interfaces/PropsStaticInterface';

export default class BookprocessWidgets extends React.Component<BookprocessWidgetProps, {}> {
    static getWidget(props: BookprocessWidgetProps) {
        switch (props.type) {
            case 'email':
                return React.createElement(Email, props as PropsEmail);
            case 'hidden':
                return React.createElement(WidgetHidden, props as PropsHidden);
            case 'group':
                return React.createElement(WidgetGroup, props as PropsGroup);
            case 'date':
                return React.createElement(WidgetDate, props as PropsDate);
            case 'static':
                return React.createElement(WidgetStatic, props as PropsStatic);
            case 'text':
            case 'tel':
                return React.createElement(WidgetText, props as PropsText);
            case 'textarea':
                return React.createElement(WidgetTextArea, props as PropsText);
            case 'number':
                return React.createElement(WidgetNumberWithButtons, props as PropsNumber);
            case 'select':
                return React.createElement(WidgetSelect, props as PropsSelect);
            default:
                return React.createElement(WidgetInput, props);
        }
    }

    render() {
        const widget = BookprocessWidgets.getWidget(this.props);
        let err;

        if ('error' in this.props && this.props.showError) {
            err = React.createElement('span', { className: 'error' }, this.props.error);
        }

        const classNames = this.props.classNames ?? [];

        if (err) {
            classNames.push('has-error');
        }

        if (this.props.required) {
            classNames.push('recras-required');
        }

        return React.createElement(
            'div',
            { className: classNames.join(' ') },
            <Label htmlFor={widget.props.id} text={this.props.label} />,
            err,
            widget
        );
    }
}
